import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import request from '@/utils/request';
export function customerInsuranceList(data) {
  return request.post('admin/v2/customer-insurance/list', data);
}
export function insuranceInfoMark(data) {
  return request.post('admin/v2/insurance/detail-by-mark', data);
}
export function classificationCustomerList(data) {
  return request.post('admin/insurance-classification/customer-list', data);
}
export function customerInsuranceDetail(data) {
  return request.post('admin/v2/customer-insurance/detail', data);
}
export function addCustomerInsurance(data) {
  return request.post('admin/v2/customer-insurance/store', data);
}
export function editCustomerInsurance(data) {
  return request.post('admin/v2/customer-insurance/edit', data);
}
export function customerClassification(data) {
  return request.post('admin/insurance-label/list-classification', data);
}
// export function delCustomerInsuranceList(data) {
//   return request.post('admin/customer-insurance/delete', data);
// }
export function customerInsuranceStatus(data) {
  return request.post('admin/customer-insurance/status', data);
}
// export function customerInsuranceTop(data) {
//   return request.post('admin/customer-insurance/top', data);
// }
export function qrConfigList(data) {
  return request.post('admin/customer-insurance/qr-config/detail', data).then(res => {
    return res.map(item => {
      item.qrConfigId = item.id;
      item.isEdit = false;
      return item;
    });
  });
}
export const CODENODE = {
  name: '',
  domain: '',
  address: '',
  appId: '',
  linkType: 'NEW_LINK',
  templateControlsGroupId: undefined,
  isEdit: true,
  id: -1
};
export function addQrConfig(data) {
  return request.post('admin/v2/customer-insurance/qr-config/store', data);
}
export function editQrConfig(data) {
  return request.post('admin/v2/customer-insurance/qr-config/edit', data);
}
export function delQrConfig(data) {
  return request.post('admin/customer-insurance/qr-config/delete', data);
}
export function templateResources(data) {
  return request.post('admin/customer-insurance/qrcodeTemplate', data);
}
export function generateQrCode(data) {
  return request.post('admin/customer-insurance/generate_qr_code', data);
}
export function generateQrCodeLink(data) {
  return request.post('admin/customer-insurance/generate_qr_code_link', data);
}
//内容管理
export function insuranceContent(data) {
  return request.post('admin/v2/customer-insurance/content', data);
}
//保费模板资源
export function premiumTemplateResource(data) {
  return request.post('admin/v2/customer-insurance/premium-template/resource', data);
}
//保费模板编辑
export function premiumTemplateStore(data) {
  return request.post('admin/v2/customer-insurance/premium-template/store', data);
}

//获取文件模板列表
export function getTemplateList(data) {
  return request.post('admin/v2/customer-insurance/set-template/list', data);
}

//获取文件模板资源
export function getTemplateResource(data) {
  return request.post('admin/v2/customer-insurance/set-template/field-template/resource', data);
}
//新增客户配置文件模板
export function addConfigurationTemplate(data) {
  return request.post('admin/v2/customer-insurance/set-template/store', data);
}
//客户配置文件模板 状态、锚点、文件配置修改
export function editConfigurationTemplate(data) {
  return request.post('admin/v2/customer-insurance/set-template/edit/set-template/info', data);
}

//获取客户配置文件模板详情
export function getConfigurationTemplateDetail(data) {
  return request.post('admin/v2/customer-insurance/set-template/detail', data);
}

//获取文件模板字段维护信息
export function getFieldMaintenance(data) {
  return request.post('admin/v2/customer-insurance/set-template/field-maintenance', data);
}

// 获取二维码模板信息
export function getQrcodeTemplate(data) {
  return request.post('admin/customer-insurance/new_qrcode_template', data);
}
// 获取产品列表模版
export function getTemplateResourceList(data) {
  return request.post('admin/customer-insurance/template_resource', data);
}